import { ButtonVariant, IStepsProps, StepsOrientation, StepsType } from '@amobee/component-library';

import { Location, LocationStrategy } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { ValidatorAdapter } from 'src/adapters/validator-adapter';
import { IFooterProp } from 'src/app/common/components/footer/footer.component';
import { CampaingStatusSteps } from 'src/app/data/constants/campaign-status-steps';
import { CampaignStatus } from 'src/app/data/constants/campaign-status.const';
import { Constants } from 'src/app/data/constants/constants.enum';
import { OrderStatus } from 'src/app/data/constants/orderStatus.enum';
import { MediaPlanOptionVO } from 'src/app/data/vo/MediaPlanOptionVO';
import { OrderVO } from 'src/app/data/vo/OrderVO';
import { PricingSummaryVO } from 'src/app/data/vo/PricingSummaryVO';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { ModalService } from 'src/app/services/modal.service';
import { environment } from 'src/environments/environment';
import { CampaignAdapter } from '../../../../../../adapters/campaign-adapter';
import { PaymentType } from '../../../../../data/constants/payment-type.const';
import { CampaignDTO } from '../../../../../data/dto/CampaignDTO';
import { CampaignVO } from '../../../../../data/vo/CampaignVO';
import { PrebuiltCampaignVO } from '../../../../../data/vo/PrebuiltCampaignVO';
import { MessageService } from '../../../../../services/message.service';
import { PaymentService } from '../../../../../services/payment.service';
import { creativeRequiredValidator, dateValidator, goalValidator, languageChannelValidator } from '../../../../../validators/customValidators';
import { FormTabName, FormTabNames } from '../../constants/FormTabNames.const';
import { CampaignOrder } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-data';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import { campaignBudgetCreativeValidator, campaignLanguageCreativeValidator, getNextUTCDate, getUTCDate } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-validators';

@Component({
    selector: 'campaign-edit',
    templateUrl: './campaign-edit.component.html',
    styleUrls: ['./campaign-edit.component.scss']
})
export class CampaignEditComponent implements OnInit, OnDestroy {

    campaignForm: FormGroup;
    campaignVO: CampaignVO;
    oldCampaignVO: CampaignVO = null;
    oldMediaOptionVO: MediaPlanOptionVO = null;
    prebuiltCampaignVOs: Array<PrebuiltCampaignVO>;
    segments: any = [];
    campaignStatus = CampaignStatus;
    formTabNames: any = FormTabNames;
    tabNames: Array<FormTabName> = [FormTabNames.CampaignDetails, FormTabNames.Audience, FormTabNames.Budget, FormTabNames.Ad];
    formTitle: string;
    isNew: boolean;
    orderStatus: OrderStatus;
    isReview: boolean;
    isReadOnly: boolean;
    isCreativeEdit: boolean = false;
    isReviewOrderSummary: boolean = false;
    orderSubmitting: boolean = false;
    mediaSubmitting: boolean = false;
    reviewingOrderSummary: boolean = false;
    iconClicking: string;
    submitted: boolean = false;
    hasApiErrorsPreviously: boolean = false;
    paymentType: string = PaymentType.CreditCard.key;
    isDurationExist: boolean = true;
    previousCampaignForm: string;
    campaignBudgetSize: number = Constants.CAMPAIGN_BUDGET_SIZE;
    pricingSummary: PricingSummaryVO;
    campaignOrders: OrderVO[];
    orderId: string;
    previousPaidOrder: OrderVO;
    nonCancelledOrder: Array<OrderVO> = [];
    defaultSelectedCreatives: Array<CreativeVO> = [];
    @ViewChild('campaignSubmittedTemplate', { static: true }) public campaignSubmittedTemplate: TemplateRef<any>;
    @ViewChild('paymentPendingTemplate', { static: true }) public paymentPendingTemplate: TemplateRef<any>;
    //Todo: add a constant file once all campaign statues are known.
    stepList = [CampaingStatusSteps.CampaignReceived, CampaingStatusSteps.AdsUploaded, '', '', CampaingStatusSteps.AwaitingAdsApproval, CampaingStatusSteps.CampaignApproved];
    stepsConfig: IStepsProps = {
        completedStep: 1,
        type: StepsType.ICON,
        orientation: StepsOrientation.HORIZONTAL
    }
    footerButtons: Array<IFooterProp> = [
        {
            variant: ButtonVariant.NEUTRAL,
            label: 'Cancel',
            onClick: () => {
                this.cancel();
            }
        },
        {
            variant: ButtonVariant.NEUTRAL,
            label: 'Save',
            isActive: () => !this.isReview && !this.isReadOnly && !this.isCreativeEdit,
            onClick: () => {
                this.save().then(() => this.redirectToListPage());
                this.iconClicking = 'Save';
            },
            showIcon: () => this.campaignForm.disabled && this.iconClicking === 'Save' ? "Process" : null,
            iconPosition: "right",
            isDisabled: () => this.campaignForm.disabled

        },
        {
            variant: ButtonVariant.NEUTRAL,
            label: 'Back',
            isActive: () => this.isReview && this.orderStatus !== OrderStatus.PAID,
            onClick: () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (this.isReviewOrderSummary) {
                    this.isReviewOrderSummary = false;
                    this.messageService.sendFormTitle(['Review and Select Media', true]);
                } else {
                    //go back to edit page
                    this.isReview = false;
                    this.messageService.sendFormTitle(this.url.path().includes('/campaign/new') ? ['New Campaign', true] : ['Edit Campaign', true]);
                }
            }
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Review',
            isActive: () => !this.isReview && this.budgetControl.value && this.name.value && !this.isReadOnly && !this.isCreativeEdit,
            onClick: () => {
                this.redirectToReview();
                this.iconClicking = 'Review';
            },
            showIcon: () => this.campaignForm.disabled && this.iconClicking === 'Review' ? "Process" : null,
            iconPosition: "right",
            isDisabled: () => this.campaignForm.disabled || this.campaignForm.invalid

        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Review Order Summary',
            isActive: () => this.isReview && this.campaignVO.budget < this.campaignBudgetSize && !this.isReviewOrderSummary && !!this.campaignVO.mediaPlanOption,
            onClick: () => {
                this.reviewOrderSummary();
                this.iconClicking = "Review Order Summary";
                this.reviewingOrderSummary = true;
            },
            showIcon: () => this.reviewingOrderSummary && this.iconClicking === 'Review Order Summary' ? "Process" : null,
            iconPosition: "right",
            isDisabled: () => this.reviewingOrderSummary
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Submit Order',
            isActive: () => this.isReview && this.campaignVO.budget >= this.campaignBudgetSize && !this.isReviewOrderSummary,
            onClick: () => {
                this.orderSubmitting = true;
                this.iconClicking = 'Submit Order';
                this.save().then(() => {
                    this.submitCampaign();
                })
            },
            showIcon: () => (this.campaignForm.disabled || this.orderSubmitting) && this.iconClicking === 'Submit Order' ? "Process" : null,
            iconPosition: "right",
            isDisabled: () => this.campaignForm.disabled || this.orderSubmitting
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Proceed to Payment',
            isActive: () => this.isReview && this.campaignVO.budget < this.campaignBudgetSize && this.isReviewOrderSummary && !!this.campaignVO.mediaPlanOption && this.orderStatus !== OrderStatus.PAID,
            onClick: () => {
                if (this.pricingSummary) {
                    if (this.paymentType === PaymentType.CreditCard.key || this.paymentType === PaymentType.MediacorpCredit.key) {
                        this.save().then(
                            () => {
                                let objType: string = Constants.CAMPAIGN;
                                let unpaidCreativeIds: number[];
                                if (this.pricingSummary.creativesCost && _.size(this.pricingSummary.creativesCost.creatives)) {
                                    objType = Constants.CAMPAIGNANDMEDIA;
                                    unpaidCreativeIds = this.pricingSummary.creativesCost.creatives.map(v => v.creativeId);
                                }

                                let pro: Array<Promise<any>> = [];
                                if (_.size(this.nonCancelledOrder)) {
                                    _.forEach(this.nonCancelledOrder, no => {
                                        pro.push(this.miscAdapter.patchPaymentStatus(no.orderId, OrderStatus.CANCELLED).then(() => {
                                            this.nonCancelledOrder = _.remove(this.nonCancelledOrder, { orderId: no.orderId });
                                        }));
                                    });
                                }
                                Promise.all(pro).then(() => {
                                    this.paymentService.order(this.pricingSummary.grandTotalCost, environment.currency, objType, [this.campaignVO.id], unpaidCreativeIds, this.paymentType, this.pricingSummary.discountCodeId)
                                        .then((campaignOrder: CampaignOrder) => {
                                            this.orderId = campaignOrder.order_id;
                                            this.setUpPaymentStatusCheck();
                                        }).catch((err) => {
                                            console.log(err);
                                            this.modal.error({ message: 'Failed to process payment, please try again' });
                                        });
                                });
                            }
                        );
                    } else {
                        this.modal.error({ message: 'Please Select Payment type to proceed' });
                    }
                } else {
                    this.modal.error({ message: 'Failed to get pricing summary of the campaign' });
                }
            },
            isDisabled: () => this.campaignForm.disabled
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Submit',
            isActive: () => this.isReview && this.campaignVO.budget < this.campaignBudgetSize && this.isReviewOrderSummary && this.orderStatus === OrderStatus.PAID,
            onClick: () => {
                this.orderSubmitting = true;
                this.submitCampaign(this.orderStatus);
            },
            isDisabled: () => this.orderSubmitting
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Submit Media',
            isActive: () => this.isCreativeEdit && !this.skipCreativeControl.value,
            onClick: () => {
                this.mediaSubmitting = true;
                this.campaignVO = Object.assign(this.campaignVO, this.campaignForm.value);
                this.submitMedia();
            },
            isDisabled: () => this.campaignForm.invalid || this.mediaSubmitting || (this.creativeControl.value.length + this.produceCreative.value.length <= this.defaultSelectedCreatives.length)
        },
        {
            variant: ButtonVariant.PRIMARY,
            label: 'Save',
            isActive: () => this.isCreativeEdit && this.skipCreativeControl.value,
            onClick: () => {
                this.mediaSubmitting = true;
                this.campaignVO = Object.assign(this.campaignVO, this.campaignForm.value);
                this.submitMedia();
            },
            isDisabled: () => this.campaignForm.invalid || this.mediaSubmitting
        }
    ];

    constructor(
        private url: LocationStrategy,
        private route: ActivatedRoute,
        private router: Router,
        private modal: ModalService,
        private messageService: MessageService,
        private paymentService: PaymentService,
        private campaignAdapter: CampaignAdapter,
        private miscAdapter: MiscAdapter,
        private validatorAdapter: ValidatorAdapter,
        private fb: FormBuilder,
        private location: Location,
        private breadcrumbService: BreadcrumbService
    ) {
    }

    ngOnInit() {
        this.paymentService.initialize();
        let data = this.route.snapshot.data;

        this.campaignForm = new CampaignDTO(this.fb).formGroup;
        this.campaignForm.setValidators(
            [
                ...this.commonCampaignValidators(),
                ...this.validatorAdapter.getCampaignValidator()
            ]
        );
        this.checkBudgetValueChange();
        this.isNew = this.url.path().includes('/campaign/new');
        this.messageService.sendFormTitle(this.isNew ? ['New Campaign', true] : ['Edit Campaign', true]);
        this.campaignAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
            if (isMultiAdvertiser) {
                this.campaignAdapter.getPlan(this.campaignVO.planId).then((resp) => {
                    this.breadcrumbService.prepareBreadcrumb(resp.customer_id, resp.advertiser_id, resp.brand_id);
                    this.campaignAdapter.updateCBAId(resp.customer_id, resp.advertiser_id, resp.brand_id);
                });
            }
        }));

        if (data.campaignData) {
            this.campaignVO = data.campaignData[0];
            this.campaignOrders = data.campaignData[2];
            this.nonCancelledOrder = _.filter(this.campaignOrders, o => o.status !== OrderStatus.CANCELLED && o.status !== OrderStatus.FAILED);
            if (data.campaignData[1]) {
                this.campaignVO.creatives = data.campaignData[1];
            }
            //create a new plan and a campaign when user enters new workflow, per requirement
            if (this.isNew === true) {
                //hide the temp campaign name if it's system generated
                if (this.campaignVO.name.indexOf('Campaign_') === 0) {
                    delete this.campaignVO.name;
                }
                // this.campaignVO.status = CampaignStatus.Draft.key;
                this.campaignForm.patchValue(this.campaignVO);
                this.previousCampaignForm = JSON.stringify(this.campaignForm.value);
                this.oldCampaignVO = cloneDeep(this.campaignVO);
                this.oldMediaOptionVO = cloneDeep(this.campaignVO.mediaPlanOption);
                if (!this.route.snapshot.paramMap.has('campaignId')) {
                    const url = this.router.createUrlTree([this.campaignVO.id], { relativeTo: this.route }).toString();
                    this.location.replaceState(url);
                }
            } else if (this.isNew === false) {
                let rejectedCreativeIds = data.campaignData[3] || [];
                if (this.campaignVO.status !== CampaignStatus.Draft.key && this.route.snapshot.queryParams.readOnly) {
                    this.campaignForm.patchValue(this.campaignVO);
                    this.previousCampaignForm = JSON.stringify(this.campaignForm.value);
                    this.campaignForm.disable();
                    this.isReadOnly = true;
                } else if (this.campaignVO.status === CampaignStatus.Pending.key || this.campaignVO.status === CampaignStatus.Ready.key) {
                    if ((this.campaignVO.skipCreative || rejectedCreativeIds.length > 0) && getUTCDate(this.campaignVO.startDate) > getNextUTCDate(3, true)) {
                        this.campaignForm.patchValue(this.campaignVO);
                        this.previousCampaignForm = JSON.stringify(this.campaignForm.value);
                        this.defaultSelectedCreatives = this.campaignVO.creatives.filter((c) => !rejectedCreativeIds.includes(c.creativeId));
                        if (this.defaultSelectedCreatives.length != this.campaignVO.creatives.length) {
                            this.creativeControl.patchValue(_.clone(this.defaultSelectedCreatives));
                        }
                        this.campaignForm.clearValidators();
                        this.campaignForm.setValidators(
                            [
                                creativeRequiredValidator(),
                                campaignLanguageCreativeValidator(),
                                campaignBudgetCreativeValidator()
                            ]
                        );
                        this.isCreativeEdit = true;
                        this.campaignForm.disable({ emitEvent: false });
                        this.skipCreativeControl.enable({ emitEvent: false });
                        this.adDurationControl.enable({ emitEvent: false });
                        this.creativeControl.enable({ emitEvent: false });
                        this.produceCreative.enable({ emitEvent: false });
                        if (this.route.snapshot.queryParams.fromCreative) {
                            setTimeout(() => {
                                window.scrollTo({ top: document.getElementById(FormTabNames.Ad.id).offsetTop, behavior: 'smooth' });
                            }, 300);
                            this.modal.info({ message: "Please select the media which is produced by MC and click the 'Submit Media' button." });
                        }
                    } else {
                        this.router.navigate(['campaign', 'summary', this.campaignVO.id]);
                    }
                } else if (this.campaignVO.status === CampaignStatus.Draft.key) {
                    let orderObj = _.find(this.campaignOrders, (order: OrderVO) => order.status === OrderStatus.PAID || order.status === OrderStatus.PROCESSING);
                    if (orderObj) {
                        this.orderStatus = orderObj.status;
                        this.orderId = orderObj.orderId;
                        this.previousPaidOrder = orderObj;
                    }
                    if (this.orderStatus === OrderStatus.PAID) {
                        this.campaignForm.disable();
                        this.isReview = true;
                        this.isReviewOrderSummary = true;
                        this.submitCampaign(this.orderStatus);
                    } else if (this.orderStatus === OrderStatus.PROCESSING) {
                        this.isReview = true;
                        this.isReviewOrderSummary = true;
                        this.reviewingOrderSummary = false;
                        this.messageService.sendFormTitle(['Complete Payment', true]);
                        //Polling payment API to get the order payment status.
                        this.setUpPaymentStatusCheck();
                    } else {
                        //If payment status is PENDING, FAILED or CANCELLED
                        this.campaignForm.patchValue(this.campaignVO);
                        this.previousCampaignForm = JSON.stringify(this.campaignForm.value);
                        this.defaultSelectedCreatives = this.campaignVO.creatives.filter((c) => !rejectedCreativeIds.includes(c.creativeId));
                        if (this.defaultSelectedCreatives.length != this.campaignVO.creatives.length) {
                            this.creativeControl.patchValue(_.clone(this.defaultSelectedCreatives));
                        }
                    }
                    this.oldCampaignVO = cloneDeep(this.campaignVO);
                    this.oldMediaOptionVO = cloneDeep(this.campaignVO.mediaPlanOption);
                } else {
                    this.redirectToListPage();
                }
            }
            //load up custom templates
            this.campaignAdapter.getPrebuiltCampaignData(this.campaignVO.id).then(resp => {
                this.prebuiltCampaignVOs = resp;
            });

            this.campaignAdapter.getSegments(this.campaignVO.id).then(segments => {
                console.log('segments', segments);
                this.segments = segments;
            });
        }
        this.campaignAdapter.getPlan(this.campaignVO.planId).then((resp) => {
            this.miscAdapter.isCreditAccountNumberApproved(resp.customer_id.toString()).then((r) => {
                this.paymentType = r ? PaymentType.MediacorpCredit.key : PaymentType.CreditCard.key;
            }).catch((err) => {
                console.log(err);
            });
        });
    }

    ngOnDestroy() {
        this.paymentService.destroy();
    }

    validateForm(isSave = false): boolean {
        this.submitted = true;
        setTimeout(() => {
            // toggle submitted back to false so that it won't cause issue when navigate back from review page
            this.submitted = false;
        }, 0);
        if (isSave) {
            //Disabling creative control to by pass the validation
            if (this.creativeControl.value.length === 0) {
                this.creativeControl.disable({ emitEvent: false });
            }
            if (this.produceCreative.value.length === 0) {
                this.produceCreative.disable({ emitEvent: false });
            }
        }
        this.markAllAsTouched(this.campaignForm);
        if (this.campaignForm.invalid) {
            if (!this.skipCreativeControl.value) {
                this.creativeControl.enable({ emitEvent: false });
                this.produceCreative.enable({ emitEvent: false });
            }
            this.modal.error({ message: 'Please resolve the validation errors marked in red before saving.' });
            return false;
        } else {
            if (!this.skipCreativeControl.value) {
                this.creativeControl.enable({ emitEvent: false });
                this.produceCreative.enable({ emitEvent: false });
            }
            if (!this.isDurationExist) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.modal.error({
                    message: 'One or more creative durations are no longer available. Please make the changes in the campaign and try to save it again.'
                });
                return false;
            }
            return true;
        }
    }

    validateCreative(): boolean {
        if (!(this.creativeControl.value.length + this.produceCreative.value.length > this.defaultSelectedCreatives.length)) {
            this.modal.error({ message: 'Add new creative to submit media.' });
            this.mediaSubmitting = false;
            return false;
        }
        return true;
    }

    submitMedia() {
        if (this.campaignVO.skipCreative || this.validateCreative()) {
            this.campaignForm.disable({ emitEvent: false });
            let creatives = this.creativeControl.value;
            this.campaignAdapter.submitMedia(this.campaignVO, creatives).then(() => {
                this.redirectToListPage();
            });
        }
    }

    save(): Promise<any> {
        if (this.validateForm(true)) {
            if (this.hasApiErrorsPreviously || this.previousCampaignForm !== JSON.stringify(this.campaignForm.value)) {
                this.isNew = false;
                this.campaignForm.disable({ emitEvent: false });
                this.campaignVO = { ...this.campaignVO, ...this.campaignForm.value };
                //original campaignVO should retain some of the ids that are not in the DTO
                console.log('before save', this.campaignVO, this.oldCampaignVO);
                let savePromise: Promise<any> = this.hasApiErrorsPreviously ? this.campaignAdapter.fullSaveAllCampaignData(this.campaignVO) :
                    this.campaignAdapter.saveAllCampaignData(this.campaignVO, this.oldCampaignVO);
                return savePromise.then(() => {
                    this.previousCampaignForm = JSON.stringify(this.campaignForm.value);
                    this.oldCampaignVO = cloneDeep(this.campaignVO);
                    this.hasApiErrorsPreviously = false;
                }, error => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    this.modal.error({
                        message: 'There was an error saving your campaign. Please try saving again.'
                    });
                    this.orderSubmitting = false;
                    this.hasApiErrorsPreviously = true;
                    console.log(error);
                    throw error;
                }).finally(() => {
                    this.campaignForm.enable({ emitEvent: false });
                    //age and gender needs to be always disabled CSYS-5551
                    this.campaignForm.get('gender').disable({ emitEvent: false });
                    this.campaignForm.get('age').disable({ emitEvent: false });
                    if (this.skipCreativeControl.value) {
                        this.creativeControl.disable();
                        this.produceCreative.disable();
                    }
                });
            } else {
                return Promise.resolve();
            }
        } else {
            return Promise.reject();
        }
    }

    cancel(): void {
        if (this.previousCampaignForm !== JSON.stringify(this.campaignForm.value)) {
            this.modal.confirmation({ message: 'Are you sure you want to discard the changes?' }, '', '',
                () => {
                    this.redirectToListPage();
                }
            );
        } else {
            this.redirectToListPage();
        }
    }

    redirectToListPage() {
        this.router.navigate(['campaign']);
    }

    submitCampaign(orderStatus?: string, closeModal?: any) {
        this.campaignAdapter.submitCampaign(this.campaignVO.id).then(() => {
            if (orderStatus === OrderStatus.PAID) {
                // case for < 100k
                this.stepsConfig.completedStep = 3;
                this.stepList[2] = CampaingStatusSteps.PaymentReceived;
                this.stepList[3] = CampaingStatusSteps.MediaPlanCreated;
            } else {
                // case for > 100k
                this.stepsConfig.completedStep = 2;
                this.stepList[2] = CampaingStatusSteps.MediaPlanCreated;
                this.stepList[3] = CampaingStatusSteps.PaymentReceived;
            }
            if (closeModal) {
                closeModal(false);
            }
            this.redirectToListPage();
            this.modal.confirmation(this.campaignSubmittedTemplate,
                'Your Campaign has been Successfully Submitted', '', undefined, undefined,
                [{
                    label: 'Ok',
                    variant: ButtonVariant.PRIMARY
                }]
            );
        }, error => {
            this.orderSubmitting = false;
            if (closeModal) {
                closeModal(false);
            }
            let errorMessage = 'There was an error while submitting your campaign, ' +
                'please try to submit again or write to addirect@mediacorp.com.sg for assistance.';
            if (orderStatus === OrderStatus.PAID) {
                errorMessage = 'Your payment is complete. ' + errorMessage;
            }
            this.modal.error({
                message: errorMessage
            });
        });
    }

    setUpPaymentStatusCheck() {
        let closeModal = this.modal.openModal({
            closeButton: false,
            headerContent: 'Thank you!',
            bodyContent: this.paymentPendingTemplate,
            hideFooterContent: true,
            disabledNonFooterClick: true
        });
        let interval = setInterval(() => {
            this.campaignAdapter.getOrder(this.orderId).then((payments: CampaignOrder) => {
                if (payments.status === 'PAID') {
                    clearInterval(interval);
                    this.orderStatus = OrderStatus.PAID;
                    this.submitCampaign(this.orderStatus, closeModal);
                }
            });
        }, Constants.PAYMENT_STATUS_CHECK_INTERVAL);
    }

    redirectToReview() {
        //need to pick up all changes into CampaignVO
        //must make sure form is valid and can be saved
        if (this.validateForm()) {
            if (this.previousCampaignForm !== JSON.stringify(this.campaignForm.value)) {
                this.campaignVO = { ...this.campaignVO, ...this.campaignForm.value };
                this.save().then(() => {
                    this.isReview = true;
                    this.messageService.sendFormTitle(['Review and Select Media', true]);
                });
            } else {
                this.isReview = true;
                this.messageService.sendFormTitle(['Review and Select Media', true]);
            }
        }
    }

    reviewOrderSummary() {
        console.log('Processing media plan option', this.campaignVO);
        this.campaignAdapter.processMediaPlanOption(this.campaignVO, this.oldMediaOptionVO).then(() => {
            this.isReview = true;
            this.isReviewOrderSummary = true;
            this.reviewingOrderSummary = false;
            this.oldMediaOptionVO = cloneDeep(this.campaignVO.mediaPlanOption);
            this.messageService.sendFormTitle(['Complete Payment', true]);
        }, error => {
            console.log(error);
            this.modal.error({ message: 'Failed to save the media plan option to the campaign, please try again' });
            this.reviewingOrderSummary = false;
        });
    }

    markAllAsTouched(control: AbstractControl, onlySelf: boolean = false) {
        control.markAsTouched({ onlySelf: true });

        if (!onlySelf) {
            if (control instanceof FormGroup) {
                Object.values((control as FormGroup).controls).forEach(val => this.markAllAsTouched(val));
            } else if (control instanceof FormArray) {
                (control as FormArray).controls.forEach(val => this.markAllAsTouched(val));
            }
        }
    }

    onPaymentChange(type: string) {
        this.paymentType = type;
    }

    durationExist(exist: boolean) {
        this.isDurationExist = exist;
    }

    checkBudgetValueChange(): void {
        this.budgetControl.valueChanges.subscribe(value => {
            if (value) {
                this.campaignVO.budget = value;
            }
        });
    }

    onPricingSummaryChange(pricingSummary: PricingSummaryVO) {
        this.pricingSummary = pricingSummary;
    }

    private commonCampaignValidators(): Array<ValidatorFn> {
        return [
            dateValidator(this.campaignAdapter, this.route.snapshot.data.campaignData[0].id),
            goalValidator(),
            languageChannelValidator(),
            creativeRequiredValidator()
        ];
    }

    get statusControl(): FormControl {
        return this.campaignForm.get("status") as FormControl;
    }

    get budgetControl(): FormControl {
        return this.campaignForm.get("budget") as FormControl;
    }

    get creativeControl(): FormControl {
        return this.campaignForm.get("creatives") as FormControl;
    }

    get produceCreative(): FormArray {
        return this.campaignForm.get('produceCreative') as FormArray;
    }

    get skipCreativeControl(): FormControl {
        return this.campaignForm.get("skipCreative") as FormControl;
    }

    get adDurationControl(): FormControl {
        return this.campaignForm.get('adDuration') as FormControl;
    }

    get name(): FormControl {
        return this.campaignForm.get('name') as FormControl;
    }
}